import { SubtitleSection } from "@domain/lms/course/courseSection";
import { SectionController } from "@ui/pages/lms/courseEditorPage/courseEditorController/sectionController";

export class SubtitleSectionController extends SectionController<SubtitleSection> {
	setTitle(title: string): void {
		this.sectionUpdater((section) => ({ ...section, title }));
	}
}
